export const navbarLinks = [
    {
        href: '/',
        name: 'home',
    },
    {
        href: '/products',
        name: 'readyServices',
    },
    {
        href: '/transforms',
        name: 'transform',
    },
    {
        href: '/contact',
        name: 'contact',
    }
]